/* eslint-disable */
import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.birdChart`;

export const INIT = `${SCOPE}/INIT`;
export const SET_SLICE_INTERVAL = `${SCOPE}/SET_SLICE_INTERVAL`;
export const SET_INVALID_RESPONSE = `${SCOPE}/SET_INVALID_RESPONSE`;
export const RESET_SLICE_INTERVAL = `${SCOPE}/RESET_SLICE_INTERVAL`;
export const SET_BIRD_CHART_STATE = `${SCOPE}/SET_BIRD_CHART_STATE`;

export const FETCHING = `${SCOPE}/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}/FETCHING_SUCCESS`;
export const FETCHING_FAILS = `${SCOPE}/FETCHING_FAILS`;

export const FETCHING_SLICE = `${SCOPE}/FETCHING_SLICE`;
export const FETCHING_SLICE_SUCCESS = `${SCOPE}/FETCHING_SLICE_SUCCESS`;
export const FETCHING_SLICE_FAILS = `${SCOPE}/FETCHING_SLICE_FAILS`;

export const RESET_RESPONSE = `${SCOPE}/RESET_RESPONSE`;

export const SET_ZOOM_RANGE = `${SCOPE}/SET_ZOOM_RANGE`;
export const SET_BRUSH_RANGE = `${SCOPE}/SET_BRUSH_RANGE`;

export const SAVE_BIRD_CHART_QUERY = `${SCOPE}/SAVE_BIRD_CHART_QUERY`;

export const SAVE_ZOOM_INTERVAL = `${SCOPE}/SAVE_ZOOM_INTERVAL`;
